var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-container",class:{'is-mobile': _vm.isMobile || _vm.isWeixin}},[_c('keep-alive',[_c('router-view')],1),_c('AppLogin',{ref:"loginDialog",attrs:{"backRoute":_vm.backRoute},on:{"login":_vm.loginOK}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }